import { createStore, applyMiddleware, compose } from "redux";
// import logger from 'redux-logger'
import thunk from "redux-thunk";
import reducer from "../reducers";

const initialState = {};
const enhancers = [];
const middleware = [thunk];

if (process.env.NODE_ENV === "development") {
  const devToolsExtension = window.devToolsExtension;

  if (typeof devToolsExtension === "function") {
    enhancers.push(devToolsExtension());
  }
}

const composedEnhancers = compose(applyMiddleware(...middleware), ...enhancers);

const store = createStore(reducer, initialState, composedEnhancers);

export default store;



// WEBPACK FOOTER //
// ./src/js/redux/store/index.js